import {filter, map} from 'rxjs/operators';
import {ChangeDetectionStrategy, Component} from '@angular/core';
import {AsyncPipe, NgClass} from '@angular/common';
import {Store} from '@ngxs/store';
import {DashboardStudyCarouselComponent} from '../dashboard-study-carousel/dashboard-study-carousel.component';
import {RtRouterDataResolverState} from '../../../rt-router-data-resolver/rt-router-data-resolver.state';
import {DashboardViewRegionsState} from '../../../dashboard-view-regions/states/dashboard-view-regions/dashboard-view-regions.state';
import {SelectViewRegion} from '../../../dashboard-view-regions/states/dashboard-view-regions/dashboard-view-regions.actions';
import {DashboardViewRegion} from '../../../dashboard-view-regions/types/dashboard-view-regions.types';

@Component({
  selector: 'app-dashboard-study-view-regions',
  templateUrl: './dashboard-study-view-regions.component.html',
  styleUrls: ['./dashboard-study-view-regions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, NgClass, DashboardStudyCarouselComponent],
})
export class DashboardStudyViewRegionsComponent {
  public readonly dashboardViewRegions$ = this.store.select(DashboardViewRegionsState.viewRegionList);
  public readonly firstLevelViewRegion$ = this.store.select(DashboardViewRegionsState.firstLevelViewRegion);
  public readonly secondLevelViewRegion$ = this.store.select(DashboardViewRegionsState.secondLevelViewRegion);
  public readonly currentRouteData$ = this.store.select(RtRouterDataResolverState.currentRouteData);

  public readonly secondLevelViewRegions$ = this.firstLevelViewRegion$.pipe(
    filter(viewRegion => !!viewRegion),
    map(viewRegion => viewRegion.subregions)
  );

  constructor(private store: Store) {}

  public setActiveSection(viewRegion: DashboardViewRegion): void {
    this.store.dispatch(new SelectViewRegion(viewRegion.id));
  }
}
